/*
    Defines the available action type
*/

/**
 * The list of available action that will be use by the RootReducer and Actions functions
 */
export enum ActionType {
    test,
    
}
